import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  input
} from "@angular/core";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: "app-progress-bar",
  templateUrl: "./progress-bar.component.html",
  encapsulation: ViewEncapsulation.None,
  imports: [MatProgressBar],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent implements OnInit {
  // Progressbar max is 100, use (100/7)*current step.
  value = input.required<number>();
  thick = input<boolean>(false);

  constructor() {}

  ngOnInit(): void {}
}
